
export const DELETE_CHAT_REQUEST: string = 'DELETE_CHAT_REQUEST';


export const deleteChatRequest = (id: string, onSuccess?: () => void) => {
  return {
    type: DELETE_CHAT_REQUEST,
    payload: { id, onSuccess }
  }
}